// Display order matching the Chart of Accounts
const orderedTypes = ["1", "2", "3", "3.1", "4", "5", "6", "6.1", "6.2", "6.3", "7", "8", "9", "10", "12", "13", "14", "11", "15", "16", "17"];

const TrialBalance = ({ trialData }) => {
    let totalDebit = 0;
    let totalCredit = 0;

    const sortedData = orderedTypes
        .map((type) => trialData.find((item) => item.type === type))
        .filter(Boolean);

    const rows = sortedData.map((item, index) => {
        /* Old Code:
        const isDebit = item.is_debit_display;
        const debit = isDebit ? item.total_amount : 0;
        const credit = !isDebit ? item.total_amount : 0;

        totalDebit += debit;
        totalCredit += credit;
        return item.total_amount ? (
            <tr key={index} className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                <td className="py-2 px-4">{item.remarks}</td>
                <td className="py-2 px-4 text-right text-green-600 font-medium">
                    {debit ? debit.toLocaleString() : "-"}
                </td>
                <td className="py-2 px-4 text-right text-red-600 font-medium">
                    {credit ? credit.toLocaleString() : "-"}
                </td>
            </tr>
        ) : <></>
        */

        // 1. Temporarily hide "Equity Balance" row and exclude from totals
        if (item.remarks === "Equity Balance") {
            return null;
        }

        // 2. Force Offers/Discounts to display on Debit instead of Credit
        let isDebit = item.is_debit_display;
        if (item.remarks && item.remarks.toLowerCase().includes("offer")) {
            isDebit = true;
        }

        const debit = isDebit ? item.total_amount : 0;
        const credit = !isDebit ? item.total_amount : 0;

        totalDebit += debit;
        totalCredit += credit;

        // return item.total_amount ? (
        const isProcessingCharges = item.type === "6.3";

        return (item.total_amount || isProcessingCharges) ? (
            <tr key={index} className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                <td className="py-2 px-4">{item.remarks}</td>
                <td className="py-2 px-4 text-right text-green-600 font-medium">
                    {/* {debit ? debit.toLocaleString() : "-"} */}
                    {(debit && !isProcessingCharges) ? debit.toLocaleString() : "-"}
                </td>
                <td className="py-2 px-4 text-right text-red-600 font-medium">
                    {/* {credit ? credit.toLocaleString() : "-"} */}
                    {(credit && !isProcessingCharges) ? credit.toLocaleString() : "-"}
                </td>
            </tr>
        ) : <></>;
    });

    let balanceRow = null;

    return (
        <div className="d-flex justify-content-center align-items-center py-4">
            <div className="w-full max-w-2xl bg-white shadow-md rounded-lg overflow-hidden">
                <h4 className="text-xl font-bold text-center bg-success text-white py-2 mb-0">
                    Trial Balance
                </h4>
                <table className="w-full table border-collapse text-sm table-hover table-bordered mb-0">
                    <thead>
                        <tr className="bg-green-500 text-white">
                            <th className="py-2 px-4 text-left">Account</th>
                            <th className="py-2 px-4 text-right">Debit (INR)</th>
                            <th className="py-2 px-4 text-right">Credit (INR)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                        {balanceRow}
                        <tr className="bg-gray-200 font-bold">
                            <td className="py-2 px-4">Total</td>
                            <td className="py-2 px-4 text-right text-green-600">
                                {totalDebit.toLocaleString()}
                            </td>
                            <td className="py-2 px-4 text-right text-red-600">
                                {totalCredit.toLocaleString()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TrialBalance;